(() => {
  const modal = document.getElementById('product-modal');

  if(modal == undefined) return;

  const close = document.getElementById('close-modal');

  close.addEventListener('click', () => {
    modal.classList.remove('open');
  });

  const action_buttons = document.querySelectorAll('.show-product');

  if(action_buttons == undefined) return;

  let title = modal.querySelector('#modal-title');
  let content = modal.querySelector('#modal-content');
  let features = modal.querySelector("#modal-features");
  let addons = modal.querySelector("#modal-addons");
  let image = modal.querySelector('#modal-image');

  action_buttons.forEach(button => {
    button.addEventListener('click', (ev) => {
      let data = JSON.parse(button.dataset.product);

      console.log(data)

      title.innerText = data.title;
      content.innerHTML = data.content;

      if(data.features == false) features.classList.add('hidden');
      if(data.addons == false) addons.classList.add('hidden');
      if(data.image == false) image.classList.add('hidden');

      if(data.features) {
        features.classList.remove('hidden');

        let feature_list = features.querySelector('ul');
        feature_list.innerHTML = '';

        data.features.forEach(feature => {
          feature_list.innerHTML += `<li>${feature.image} ${feature.feature}</li>`;
        });
      }

      if(data.addons) {
        console.log(data.addons)
        addons.classList.remove('hidden');

        let addon_list = addons.querySelector('ul');
        addon_list.innerHTML = '';

        data.addons.forEach(addon => {
          addon_list.innerHTML += `<li>${addon.image} ${addon.addon}</li>`;
        });
      }

      if(data.image) {
        image.classList.remove('hidden');

        image.innerHTML = data.image;
      }

      modal.classList.add('open');
    });
  });
})();